<!--<template>
  <div :class="inlinerows == 'true' ? margins + ' row' : margins">
    <label v-if="label" for="exampleFormControlInput1" :class="inlinerows == 'true' ? 'col-sm-2 col-form-label' : 'form-label'">{{ label }}</label>
    <div :class="inlinerows == 'true' ? 'col-sm-10' : ''">
-->     


<template>
  <div :class="inlinerows == 'true' ? inlinerowclasses + ' row' : inlinerowclasses">
    <label v-if="label" for="exampleFormControlInput1" :class="inlinerows == 'true' ? inlineLabelClass + ' col-form-label' : 'form-label'">{{ label }}</label>
    <div :class="inlinerows == 'true' ? inlineInputClass : label ? '' : 'col-md-12'">
      

     
      <div class="switch-container">
        <div class="switch-info" v-if="labelDisable">
          <label class="unchecked switch-info-label">{{ labelDisable }} </label>
        </div>

        <div class="switch switch default round ml-2 mr-2">
          <label>
            <input type="checkbox" class="module-loader-input" v-model="ischecked" @change="handleCheck($event)" />
            <span></span>
          </label>
        </div>

        <div class="switch-info" v-if="labelEnable">
          <label class="checked switch-info-label">{{ labelEnable }}</label>
        </div>
      </div>
   
         <small class="input-error" v-if="error">{{ error }}</small>
    </div>
  </div>
</template>

<script>
import "../../assets/scss/toggle.scss";
import "../../assets/scss/form-group.scss";

export default {
  name: "toggle-simple",

  data() {
    return {
      ischecked: this.$props.checked,
    };
  },

  props: {


    
    label: {
      type: String,

    },
    inlinerows: {
      default: false,
    },
    inlinerowclasses: {
      default: "mb-3",
    },
    inlineLabelClass: {
      default: "col-sm-2",
    },
    inlineInputClass: {
      default: "col-sm-10",
    },
    error: {
      type: String,
      default: "",
    },


    // inlinerows: {
    //   // type: Boolean,
    //   default: false,
    // },
    // margins: {
    //   default: "mb-3",
    // },
    // label: {
    //   type: String,
    //   default: "",
    // },








    checked: {
      default: true,
    },

    labelEnable: {
      type: String,
      default: "Yes",
    },
    labelDisable: {
      type: String,
      default: "No",
    },

    classes: {
      type: String,
      default: "",
    },

  },

  computed: {},

  methods: {
    handleCheck(event) {
      return this.$emit("toggle", event.target.checked);
    },
  },
};
</script>
